import { useState, useCallback } from "react";
import { RestaurantCard } from "@/components/RestaurantCard";
import { Button } from "@/components/ui/button";
import type { RestaurantWithEventSpaces } from "@/types/restaurant";

const PAGE_SIZE = 12;

interface RestaurantListContentProps {
  restaurants: RestaurantWithEventSpaces[];
}

export const RestaurantListContent = ({ restaurants }: RestaurantListContentProps) => {
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);

  const showMore = useCallback(() => {
    setVisibleCount((prev) => prev + PAGE_SIZE);
  }, []);

  const visible = restaurants.slice(0, visibleCount);
  const hasMore = visibleCount < restaurants.length;

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5">
        {visible.map((restaurant) => (
          <RestaurantCard key={restaurant.id} restaurant={restaurant} />
        ))}
      </div>
      {hasMore && (
        <div className="flex justify-center pt-2">
          <Button variant="outline" size="lg" onClick={showMore}>
            Show More ({restaurants.length - visibleCount} remaining)
          </Button>
        </div>
      )}
    </div>
  );
};